/*
 * @Date: 2020-03-12 17:26:55
 * @LastEditTime: 2020-03-13 23:44:15
 * @Description: file content
 */
import './plugins/url-polyfill'
import Vue from 'vue'
import axios from 'axios'
// TODO registerServiceWorker未完成
// import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import i18n from './plugins/i18n'
import './style/main.scss'
import './plugins/element-ui'
import './plugins/vuetify-toast'
import './plugins/mobile-detect'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT || 'http://localhost:8088'

Vue.config.productionTip = false
Vue.prototype.$dev = process.env.NODE_ENV !== 'production'
Vue.prototype.$bus = new Vue()
Vue.prototype.log = function(...args){
  console.log.apply(console, args)
}
console.log('mode:', process.env.NODE_ENV)
if(Vue.prototype.$dev){
  console.log('VUE_APP_API_ENDPOINT', process.env.VUE_APP_API_ENDPOINT)
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
